import React from 'react'
import { Card } from 'reactstrap'
import Breadcrumb from '../../components/common/breadcrumb'
import SorgulamaEkrani from '../../components/common/sorgulama-component/sorgulama-ekrani'
import useFormatMessage from '../../utils/useFormatMessage'

const LimanGiris = () => {
    const { t } = useFormatMessage();
    return (
        <>
            <Breadcrumb current={t("Liman Giriş")} />
            <Card className='p-4'>
                <SorgulamaEkrani apiEndpoint="/arac-sorgulari" />
            </Card>
        </>
    )
}

export default LimanGiris